import Reveal from "@/components/Reveal";
import { ArrowUpRight, Instagram, Mail, Phone } from "lucide-react";
import { SITE } from "@/data/site";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="bg-pine py-24 text-bone lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-clay">
            <span className="h-px w-10 bg-clay" /> Contact
          </p>
          <h2 className="max-w-3xl font-serif text-4xl font-light leading-tight tracking-tighter sm:text-5xl lg:text-6xl" data-testid="contact-heading">
            Ready when your body is.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <div className="space-y-10">
              <a href={`mailto:${SITE.email}`} data-testid="contact-email" className="group flex items-center gap-6">
                <span className="flex h-14 w-14 items-center justify-center rounded-full border border-bone/20 transition-colors duration-300 group-hover:border-clay group-hover:bg-clay/10">
                  <Mail className="h-5 w-5 text-clay" />
                </span>
                <span>
                  <span className="block text-xs uppercase tracking-[0.25em] text-bone/50">Email</span>
                  <span className="mt-1 block font-serif text-3xl font-light transition-colors duration-300 group-hover:text-clay lg:text-4xl">{SITE.email}</span>
                </span>
              </a>
              {SITE.locations.map((loc) => (
                <a key={loc.id} href={loc.phoneHref} data-testid={`contact-phone-${loc.id}`} className="group flex items-center gap-6">
                  <span className="flex h-14 w-14 items-center justify-center rounded-full border border-bone/20 transition-colors duration-300 group-hover:border-clay group-hover:bg-clay/10">
                    <Phone className="h-5 w-5 text-clay" />
                  </span>
                  <span>
                    <span className="block text-xs uppercase tracking-[0.25em] text-bone/50">{loc.clinic}</span>
                    <span className="mt-1 block font-serif text-3xl font-light transition-colors duration-300 group-hover:text-clay lg:text-4xl">{loc.phone}</span>
                  </span>
                </a>
              ))}
              <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="contact-instagram" className="group flex items-center gap-6">
                <span className="flex h-14 w-14 items-center justify-center rounded-full border border-bone/20 transition-colors duration-300 group-hover:border-clay group-hover:bg-clay/10">
                  <Instagram className="h-5 w-5 text-clay" />
                </span>
                <span>
                  <span className="block text-xs uppercase tracking-[0.25em] text-bone/50">Instagram</span>
                  <span className="mt-1 block font-serif text-3xl font-light transition-colors duration-300 group-hover:text-clay lg:text-4xl">@rmtjordan</span>
                </span>
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.15} className="flex flex-col justify-end lg:col-span-4 lg:col-start-9">
            <p className="max-w-xs text-sm leading-relaxed text-bone/60">
              The fastest way to book is online — real-time availability and
              instant confirmation at either clinic. Choose whichever location
              suits your day.
            </p>
            <div className="mt-8 flex flex-col items-start gap-4">
              {SITE.locations.map((loc) => (
                <a
                  key={loc.id}
                  href={loc.bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`contact-book-${loc.id}`}
                  className="group inline-flex w-fit items-center gap-3 rounded-full bg-bone px-8 py-4 text-xs uppercase tracking-[0.2em] text-pine transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/20"
                >
                  Book — {loc.area}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
